import { NavItemType } from 'types';
import { getAllUnifiedViewMenuItems } from 'utils/chat-sidebar-unified-statuses';

/**
 * תצוגות שיחות — קטלוג כל צירופי הטווח×סטטוס. הקבוצה הזו אינה מרונדרת ישירות:
 * היא משמשת להתאמת נתיב (הדגשת השורה הפעילה) ולזיהוי תצוגות יתומות.
 *
 * הרינדור בפועל ב-NavGroup (item.id === 'views-pages'): `ChatViewsScopeAccordions`
 * — תיקיות אקורדיון בתפריט פתוח, רשימה שטוחה בתפריט מכווץ — ובתוכן
 * `UnifiedChatStatusList` לשורות המובנות ו-`AdditionalViews` לדיאלוגי התצוגות המותאמות.
 */
const viewsPages: NavItemType = {
  id: 'views-pages',
  title: 'sidebar.nav.views',
  type: 'group',
  children: getAllUnifiedViewMenuItems(),
};

export default viewsPages;
